import React, { FC } from "react";
import { faShieldCheck } from "@fortawesome/pro-regular-svg-icons/faShieldCheck";
import { faShieldCheck as faShieldCheckSolid } from "@fortawesome/pro-solid-svg-icons/faShieldCheck";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

export const ShieldCheck: FC<Omit<FontAwesomeIconProps, "icon">> = (props) => (
  <FontAwesomeIcon icon={faShieldCheck} {...props} />
);

export const ShieldCheckSolid: FC<Omit<FontAwesomeIconProps, "icon">> = (props) => (
  <FontAwesomeIcon icon={faShieldCheckSolid} {...props} />
);
